import {
  getSpecificTimeTimestampInSeconds,
  getForwardNDayTimestampInSeconds,
} from '../../common/utils/handleCaptialFlowChartData';
export const url = {
  tradeDate: '/dataapi/trade_day/astock/find_offset/',
  indexCommon: '//dataq.10jqka.com.cn/fetch-data-server/fetch/v1/specific_data',
  indexInterval: '//dataq.10jqka.com.cn/fetch-data-server/fetch/v1/interval_data'
};

export const hsgtCode = {
  hgt: '16:1A0001', //沪股通 
  sgt: '32:399001', //深股通
  lgt: '48:883957', //陆股通
};

//沪深港通每日额度余额传参
export const hsgtQuotaBalanceParams = {
  indexes: [
    {
      index_id: 'hsgt_quota_balance', //沪深港通每日额度余额
    },
  ],
  code_selectors: {
    include: [
      {
        type: 'stock_code',
        values: [hsgtCode.hgt, hsgtCode.sgt],
      },
    ],
  },
};

//陆股通主力净流入传参
export const hsgtMainMoneyParams = {
  indexes: [
    {
      codes: [hsgtCode.lgt, hsgtCode.hgt, hsgtCode.sgt],
      index_info: [
        {
          index_id: 'hsgt_main_money',
        },
      ],
    },
  ],
  time_range: {
    time_type: 'TREND',
    start: '',
    end: '',
  },
};

//北向资金净买入近1500交易日传参
export const hsgtNetBuyAndAccumulatedNetBuyParams = {
  indexes: [
    {
      codes: [hsgtCode.lgt, hsgtCode.hgt, hsgtCode.sgt],
      index_info: [
        {
          index_id: 'hsgt_net_buy',
        },
        {
          index_id: 'hsgt_accumulated_net_buy',
        },
      ],
    },
  ],
  time_range: {
    time_type: 'DAY_1',
    start: String(getForwardNDayTimestampInSeconds(1500)),
    end: String(getSpecificTimeTimestampInSeconds(Date.now(),23, 59)),
  },
};

//北向资金净买入传参
export const hsgtNetBuyParams = {
  indexes: [
    {
      index_id: 'hsgt_net_buy', //北向资金净买入
    },
  ],
  code_selectors: {
    include: [
      {
        type: 'stock_code',
        values: [hsgtCode.lgt, hsgtCode.hgt, hsgtCode.sgt],
      },
    ],
  },
};

//沪深港通交易状态传参
export const hsgtTradeStatusParams = {
  indexes: [
    {
      index_id: 'hsgt_trade_status',
    },
  ],
  code_selectors: {
    include: [
      {
        type: 'stock_code',
        values: [hsgtCode.lgt],
      },
    ],
  },
};

//沪深股通交易状态原因说明传参
export const hsgtTradeStatusReasonParams = {
  indexes: [
    {
      index_id: 'hsgt_trade_status_msg',
    },
  ],
  code_selectors: {
    include: [
      {
        type: 'stock_code',
        values: [hsgtCode.lgt],
      },
    ],
  },
}

export const hsgtTradeStatusMap = {
  1: '未开盘',
  2: '即将开盘',
  3: '交易中',
  4: '午间休市',
  5: '已收盘',
  6: '休市中',
};

